module.exports = __webpack_public_path__ + "static/img/edge_img_4.0287026c.png";